import { useCallback, useState } from 'react';

const useCbtVenueScreen = () => {
  const [venueSelectionMode, setVenueSelectionMode] = useState(null);

  const openCbtVenueSelection = useCallback((mode = 'buy') => {
    setVenueSelectionMode(typeof mode === 'string' ? mode : 'buy');
  }, []);

  const closeCbtVenueSelection = useCallback(() => {
    setVenueSelectionMode(null);
  }, []);

  return {
    showCbtVenueSelection: Boolean(venueSelectionMode),
    isEditMode: venueSelectionMode === 'edit',
    openCbtVenueSelection,
    closeCbtVenueSelection
  };
};

export default useCbtVenueScreen;
